import React from 'react';
import Image from 'next/image';

import { catDictionary, CatImageVariantT } from './dictionary';

interface CatImagePropsI {
  width?: number;
  height?: number;
  variant?: CatImageVariantT;
}

const CatImage = ({ width = 72, height = 72, variant = 'welcome' }: CatImagePropsI) => {
  return (
    <Image
      src={catDictionary[variant]?.src}
      alt={catDictionary[variant]?.alt}
      width={width}
      height={height}
    />
  );
};

export default CatImage;
